import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MaterialUICard from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import Project from '../../assets/images/project.png';
import Voucher from '../../assets/images/voucher.png';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
  root: {
    margin: '20px',
    backgroundColor: '#FDFDFE',
    height: '100%'
  },
  big: {
    width: '345px'
  },
  small: {
    width: '250px'
  },
  media: {
    backgroundSize: 'contain',
    paddingTop: '56.25%', // 16:9
  },
  avatar: {
    backgroundColor: red[500]
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  sourceRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  description: {
    textAlign: 'center'
  },
  content: {
    padding: '16px !important'
  },
  clickable: {
    cursor: 'pointer'
  },
  padding: {
    padding: '5px'
  }
});

const Card = ({ projectId, name, category, creationDate, image, description, originalPrice, additionalPrice, voucherPrice, source, creatorName, creatorPhoto, clickable, showHeader, isOwner, onBuyClicked }) => {
  const classes = useStyles();
  const history = useHistory();

  const isProject = typeof originalPrice === 'undefined';
  const defaultImage = isProject ? Project : Voucher;

  const onCardClicked = () => {
    if (clickable) {
      history.push(`/project/${projectId}`);
    }
  };

  return (
    <MaterialUICard className={`${classes.root} ${clickable ? classes.clickable : ''} ${showHeader ? classes.big : classes.small}`} raised={true} onClick={onCardClicked}>
      {showHeader &&
        <CardHeader
          avatar={
            <Avatar className={classes.avatar} alt={creatorName} src={creatorPhoto} />
          }
          title={`${name} | ${category}`}
          subheader={creationDate}
        />
      }
      <CardMedia
        className={classes.media}
        image={image ? image : defaultImage}
      />
      <CardContent className={classes.content}>
        <Typography
          variant={showHeader ? "body2" : "body1"}
          color="textSecondary"
          component="p"
          className={classes.description}
        >
          {description}
        </Typography>
        {!isProject &&
          <>
            <div className={classes.row}>
              <Typography variant="body1" component="p">
                Today:
              </Typography>
              <Typography variant="body1" component="p">
                Order day:
              </Typography>
              <Typography variant="body1" component="p">
                Before:
              </Typography>
            </div>
            <div className={classes.row}>
              <Typography variant="body1" component="p">
                <b>{voucherPrice}€</b>
              </Typography>
              <Typography variant="body1" component="p">
                <b>{additionalPrice}€</b>
              </Typography>
              <Typography variant="body1" component="p">
                <strike>{originalPrice}€</strike>
              </Typography>
            </div>
            {!isOwner &&
              <div className={`${classes.row} ${classes.padding}`}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onBuyClicked}
                >
                  BUY
                </Button>
              </div>
            }
          </>
        }
        {!isProject &&
          <div className={classes.sourceRow}>
            <Typography variant="caption" component="p">
              Source: <b>{source || "FutureFunder"}</b>
            </Typography>
          </div>
        }
      </CardContent >
    </MaterialUICard >
  );
};

export default Card;
